import React from "react"
import { useIntl } from "react-intl"
import { CustomTreeDataTypeHelper } from "./domain"
import { ResponsiveTreeMap } from "@nivo/treemap"
import { formatPercentage, ONE, TWO_DECIMALS } from "helpers/numbers"
import { WHITE_COLOR } from "./constants"

interface TreeMapProps {
	data: Array<any>
	colorPalette: any
}

export const TreeMap: React.FC<TreeMapProps> = ({ data, colorPalette }) => {
	const intl = useIntl()

	return (
		<ResponsiveTreeMap
			data={{ children: data }}
			identity="name"
			value="value"
			labelSkipSize={12}
			labelTextColor={WHITE_COLOR}
			leavesOnly={true}
			innerPadding={6}
			colors={colorPalette}
			borderColor={{ theme: "background" }}
			nodeOpacity={1}
			label={function (e) {
				const formattedData: CustomTreeDataTypeHelper = e.data
				const formattedLabel = intl.formatMessage({
					id: formattedData.name,
				})
				return `${formattedLabel} ${formatPercentage(
					formattedData.value,
					ONE,
					true
				)} (${formatPercentage(
					formattedData.variation,
					TWO_DECIMALS,
					true
				)} ${intl.formatMessage({
					id:
						"phronesis.transactional.application.growth-profiling.customer-segmentation.variationlastperiod",
				})})`
			}}
			tooltip={() => null}
		/>
	)
}
